// extracted by mini-css-extract-plugin
export var carrierTab = "_3i-0";
export var carrierTabActive = "_3i-1 _3i-0";
export var carrierTabInactive = "_3i-2 _3i-0";
export var carrierTabLabel = "_3i-3";
export var carrierTabLabelActive = "_3i-4 _3i-3";
export var carrierTabLabelInactive = "_3i-5 _3i-3";
export var carrierTabPercentage = "_3i-6";
export var carrierTabPercentageActive = "_3i-7 _3i-6";
export var carrierTabPercentageInactive = "_3i-8 _3i-6";
export var carrierTabWinnable = "_3i-9";
export var carrierTabWinnableActive = "_3i-a _3i-9";
export var carrierTabWinnableInactive = "_3i-b _3i-9";
export var comparisonContainer = "_3i-d";
export var missingRateButton = "_3i-n";
export var missingRateButtonActive = "_3i-o _3i-n";
export var missingRateButtonInactive = "_3i-p _3i-n";
export var missingRateButtonLabel = "_3i-q";
export var missingRateButtonLabelActive = "_3i-r _3i-q";
export var missingRateButtonLabelInactive = "_3i-s _3i-q";
export var sidebar = "_3i-c";
export var strategyButton = "_3i-e";
export var strategyButtonActive = "_3i-f _3i-e";
export var strategyButtonDescription = "_3i-k";
export var strategyButtonDescriptionActive = "_3i-l _3i-k";
export var strategyButtonDescriptionInactive = "_3i-m _3i-k";
export var strategyButtonInactive = "_3i-g _3i-e";
export var strategyButtonLabel = "_3i-h";
export var strategyButtonLabelActive = "_3i-i _3i-h";
export var strategyButtonLabelInactive = "_3i-j _3i-h";
export var unitToggleButton = "_3i-t";
export var unitToggleButtonActive = "_3i-u _3i-t";
export var unitToggleButtonInactive = "_3i-v _3i-t";
export var unitToggleButtonLabel = "_3i-w";
export var unitToggleButtonLabelActive = "_3i-x _3i-w";
export var unitToggleButtonLabelInactive = "_3i-y _3i-w";